export class StructuredOperationApproveReservationModel {
  ticketId: number = null;
  reservation: string = null;
  groupId: number = null;
  user: string = null;
}
